import React from "react";
import styled from "styled-components";

const ChartContainer = styled.div`
  width: 100%;
`;

const BarContainer = styled.div`
  margin-bottom: 10px;
`;

const BarLabel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 14px;
`;

const Bar = styled.div`
  height: 30px;
  background: #ff9800;
  border-radius: 4px;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  padding: 0 10px;
  color: white;
  font-weight: bold;
  font-size: 12px;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  color: #666;
`;

const CuisineDemandChart = ({ data, loading }) => {
  if (loading) {
    return <LoadingMessage>Loading chart...</LoadingMessage>;
  }

  if (!data || data.length === 0) {
    return <LoadingMessage>No cuisine demand data available.</LoadingMessage>;
  }

  const maxCount = Math.max(...data.map((d) => d.count), 1);

  return (
    <ChartContainer>
      {data.map((item, index) => (
        <BarContainer key={index}>
          <BarLabel>
            <span>{item.cuisine || "(unspecified)"}</span>
            <span>{item.count.toLocaleString()}</span>
          </BarLabel>
          <Bar style={{ width: `${(item.count / maxCount) * 100}%` }}>
            {item.count}
          </Bar>
        </BarContainer>
      ))}
    </ChartContainer>
  );
};

export default CuisineDemandChart;
